// From https://codepen.io/claviska/pen/vAgmd
Ready(() => {
  // We can attach the `change` event to all file inputs on the page
  document.addEventListener('change', event => {
    const input = event.target
    if (input.type !== 'file') return

    const numFiles = input.files ? input.files.length : 1
    const label = input.value.replace(/\\/g, '/').replace(/.*\//, '')

    // Create and dispatch custom event
    const fileSelectEvent = new CustomEvent('fileselect', {
      bubbles: true,
      detail: { numFiles, label }
    })
    input.dispatchEvent(fileSelectEvent)
  })

  // We can watch for our custom `fileselect` event like this
  document.addEventListener('fileselect', event => {
    const fileInput = event.target
    const inputGroup = fileInput.closest('.input-group')
    if (!inputGroup) return

    const textInput = inputGroup.querySelector('input[type="text"]')
    const numFiles = event.detail.numFiles
    const label = event.detail.label
    const log = numFiles > 1 ? numFiles + ' files selected' : label

    if (textInput) {
      textInput.value = log
    } else {
      // if(log) alert(log)
    }
  })

  // Reset Button From
  // https://www.gyrocode.com/articles/how-to-reset-file-input-with-javascript/
  document.addEventListener('click', event => {
    const resetBtn = event.target.closest('.btn-reset')
    if (!resetBtn) return

    const fileInputs = document.querySelectorAll('.sa-file')
    fileInputs.forEach(el => {
      const form = document.createElement('form')
      const parent = el.parentNode

      // Replace element with form containing element
      parent.replaceChild(form, el)
      form.appendChild(el)

      // Reset form
      form.reset()

      // Replace form with just the element
      parent.replaceChild(el, form)
    })
  })
})
